module.exports = __webpack_public_path__ + "img/ic_32_sport_american_football.a71260a2.svg";